import React from 'react';
import {
  Box, Card, Stack, IconButton, Typography,
  CardContent,
  ButtonBase,
} from '@mui/material';
import appStrings from 'common/app_strings';
import { useAppState, useAppStateDispatch, actions } from '../../../providers/app-state/app-state-provider';
import { openInBrowser } from '../../../helpers/broswer';
import {
  cardWrapperSx,
  cardGridSx,
  cardStickerWrapperSx,
  cardStickerSx,
  cardContentSx,
  cardTitleSx,
  cardBodySx,
  cardLinkSx,
  cardLinkWrapperSx,
  cardDismissWrapperSx,
  cardDismissButtonSx,
} from './GrowBannerStyles';
import { XCircle, ArrowRight } from './GrowBannerIcons';

const GROW_URL = import.meta.env.VITE_GROW_URL;

const { growBanner } = appStrings;

const GrowBanner = () => {
  const { banners: { showGrow }, platform: { isNativePlatform } } = useAppState();
  const appStateDispatch = useAppStateDispatch();
  const dismissGrowBanner = () => {
    appStateDispatch(actions.setShowGrowBanner(false));
  };

  const navigateToGrow = async () => {
    await openInBrowser(GROW_URL);
  };

  if (!showGrow || isNativePlatform) return null;
  return (
    <Card sx={cardWrapperSx}>
      <Box sx={cardGridSx}>
        <Box sx={cardStickerWrapperSx}>
          <Box component="img" src="/assets/general-landing-hero.png" alt="Grow Sticker" sx={cardStickerSx} />
        </Box>
        <CardContent sx={cardContentSx}>
          <Stack spacing={1}>
            <Typography sx={cardTitleSx}>
              {growBanner.title}
            </Typography>
            <Typography sx={cardBodySx}>
              {growBanner.description}
            </Typography>
            <ButtonBase
              sx={cardLinkWrapperSx}
              disableRipple
              onClick={navigateToGrow}
            >
              <Typography sx={cardLinkSx} component="span">
                {growBanner.link}
              </Typography>
              <ArrowRight />
            </ButtonBase>
          </Stack>
        </CardContent>
        <Box sx={cardDismissWrapperSx}>
          <IconButton
            onClick={dismissGrowBanner}
            sx={cardDismissButtonSx}
            disableRipple
          >
            <XCircle />
          </IconButton>
        </Box>
      </Box>
    </Card>
  );
};

export default GrowBanner;
